import makeRequest from '@jg/http-client';
import { Auth } from '@jg/auth';
import { ThunkDispatch } from 'redux-thunk';
import { Action } from 'redux';
import { httpActions } from '..';
import { REQUEST, ERROR_MESSAGES } from '../../consts';
import config from '../../config';
import { IAppState } from '../../types/state.d';
import { generateAuthHeaders, redirectByResponseStatus } from '../../utils';
import { getTeamGuid } from '../../selectors/apiSelectors';

const deleteTeam = () => async (
  dispatch: ThunkDispatch<IAppState, Auth, Action>,
  getState: () => IAppState,
  auth: Auth,
) => {
  const resourceName = REQUEST.DELETE_TEAM;
  try {
    await auth.refreshAccessTokenIfExpired();
    dispatch(httpActions.httpRequestMade(resourceName));
    const state = getState();
    const teamGuid = getTeamGuid(state) as string;
    const response = await makeRequest(
      `${config.pagesAPI}v1/teams/${teamGuid}`,
      {
        method: 'DELETE',
        extraHeaders: generateAuthHeaders(auth),
      },
    );
    if (response && !response.ok) {
      redirectByResponseStatus(response.status);
      throw new Error(ERROR_MESSAGES.DELETE_TEAM);
    }
    dispatch(httpActions.httpRequestSuccess(resourceName));
    window.location.assign(config.profileUri);
  } catch (error) {
    dispatch(httpActions.httpRequestError(resourceName, error));
    redirectByResponseStatus(error.status);
  }
};

export default deleteTeam;
